import React from 'react'
import './footer.css'

function Footer() {
  return (
<footer className='footer'>
    Copyright &#169; 2024  Neeraj Yadav. All right received. 
</footer>
  )
}

export default Footer;
